import type { Timestamp } from 'firebase/firestore';

export function formatCompactCount(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(value >= 10_000 ? 0 : 1)}K`;
  return String(value);
}

export function formatTimestamp(timestamp?: Timestamp): string {
  if (!timestamp) return 'Just now';
  return new Intl.DateTimeFormat('en', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(timestamp.toDate());
}

export function initialsFor(nameOrEmail: string): string {
  const source = nameOrEmail.trim();
  if (!source) return 'IF';
  const words = source.includes('@') ? [source[0]] : source.split(/\s+/).slice(0, 2);
  return words.map((word) => word[0]?.toUpperCase() ?? '').join('') || 'IF';
}
